import { Icon } from '@/modules/Icon';
import { faCalendar, faHashtag, faListUl, faText } from '@fortawesome/pro-regular-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { ColumnDataType } from '../../types/filter';
const ICON_MAP: Record<ColumnDataType, IconDefinition> = {
  text: faText,
  number: faHashtag,
  list: faListUl,
  date: faCalendar,
};

export const FilterIcon = ({ type }: { type: ColumnDataType }) => {
  const icon = ICON_MAP[type];
  if (!icon) return null;

  return <Icon name={icon} color="blue" size="sm" />;
};
